import $ from 'jquery';

const videoModal = () => {
    if (document.querySelector('.ume-video-box-trigger-wrapper')) {
        const portrait = window.matchMedia("(orientation: portrait)").matches;
        let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
        let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
        const allBoxes = document.querySelectorAll('.ume-video-box-trigger-wrapper');
        allBoxes.forEach(b => {
            let modal = b.querySelector('.ume-video-box-modal');
            let content = modal.querySelector('.modal-content');
            let horizontal = content.getAttribute('data-video-horizontal');
            let vertical = content.getAttribute('data-video-vertical');
            let body = content.querySelector('.modal-body')
            let video = body.querySelector('.ume-video-box-video');

            if (portrait) {
                let videoWidth = (vw / 100) * 80
                let videoHeight = (16 / 9) * videoWidth;
                if ((videoHeight + 20) > vh) {
                    videoWidth = (vw / 100) * 60
                    videoHeight = (16 / 9) * videoWidth;
                }
                modal.style.setProperty('--ume-video-box-video-width', `${videoWidth}px`);
                modal.style.setProperty('--ume-video-box-video-height', `${videoHeight}px`);
                video.src = vertical;
            }
            if (!portrait) {
                let videoWidth = (vw / 100) * 80;
                let videoHeight = (9 / 16) * videoWidth;
                if ((videoHeight + 50) > vh) {
                    videoWidth = (vw / 100) * 60
                    videoHeight = (9 / 16) * videoWidth;
                }
                modal.style.setProperty('--ume-video-box-video-width', `${videoWidth}px`);
                modal.style.setProperty('--ume-video-box-video-height', `${videoHeight}px`);
                video.src = horizontal;
            }
            $(modal).on('show.bs.modal', function (event) {


                video.setAttribute('tabindex', 1)
                video.play();
            })
            $(modal).on('hidden.bs.modal', function (event) {
                video.setAttribute('tabindex', -1)
                video.pause();
            })
        })


    }
}
export default videoModal;